import { Button } from "react-bootstrap";
import { SectionPermissionTypeEnum } from "../../types/SectionPermissionTypesEnum";
import { DocumentPanelItem } from "./types";


interface DocumentsRowActionsProps<T extends DocumentPanelItem> {
    object: T;
    sectionPermission: SectionPermissionTypeEnum;
    onDelete?: (object: T) => void;
    canDelete?: (object: T) => boolean;
    onInfo?: (object: T) => void;
    canInfo?: (object: T) => boolean;
    onStar?: (object: T) => void;
    canStar?: (object: T) => boolean;
    onFileNameClick?: (object: T) => void;
    canFileNameClick?: (object: T) => boolean;
    onIcon?: (object: T) => void;
    onDownload?: (object: T) => void;
    t: (key: string) => string;
}

export function DocumentsRowActions<T extends DocumentPanelItem>({ object, onDelete, canDelete, onInfo, canInfo, onStar ,onIcon,canStar,onDownload,onFileNameClick,canFileNameClick, t }: DocumentsRowActionsProps<T>) {

    //const permissions = useUserPermissions();
    const canDeleteRow = canDelete ? canDelete(object) : true;

    const canStarRow =
        typeof canStar === "function"
            ? canStar(object)
            : true;

    const canInfoRow =
        typeof canInfo === "function"
            ? canInfo(object)
            : true;

    const canFileNameClickRow =
        typeof canFileNameClick === "function"
            ? canFileNameClick(object)
            : true;


    return (
        <div className="d-inline-flex align-items-center justify-content-end gap-2 w-100">
            {onStar && canStarRow && (
                <Button
                    variant="link"
                    onClick={() => onStar(object)}
                    title={object.isStarred ? t("common:documents.unstarDocument") : t("common:documents.starDocument")}
                    style={{ padding: 0, lineHeight: 1, color: object.isStarred ? "#ffc107" : "#adb5bd", border: "none", boxShadow: "none" }}
                >
                    <i className={object.isStarred ? "bi bi-star-fill" : "bi bi-star"} />
                </Button>
            )}
            {onIcon && (
            <Button
                type="button"
                variant="link"
                className="p-0 text-danger text-decoration-none"
                aria-label={t("common:buttons.buttonDelete")}>
                     <i className="bi bi-filetype-pdf"></i>
                </Button>
            )}
            {onFileNameClick && canFileNameClickRow && (
                <button
                    type="button"
                    onClick={() => onFileNameClick(object)}
                    style={{  flex: 1, textAlign: "left", background: "transparent", border: "none", padding: 0, fontSize: "13px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                    title={object.fileName}
                >
                    {object.fileName}
                </button>
            )}
            {onDelete && 
                canDeleteRow && (
                <Button
                type="button"
                variant="link"
                className="p-0 text-danger text-decoration-none"
                onClick={() => onDelete(object)}
                aria-label={t("common:buttons.buttonDelete")}>
                     <i className="bi bi-x-lg"></i>
                </Button>
            )}
            {onInfo && canInfoRow && (

            <Button variant="link"
                title={t("common:documents.documentInfo")}
                style={{ padding: 0, lineHeight: 1, color: "black", border: "none", boxShadow: "none" }} 
                onClick={() => { onInfo(object) }}>
                <i className="bi bi-info-circle" />
            </Button>
            )}
            {onDownload && canInfoRow && (

            <Button variant="link"
                title={t("common:documents.downloadDocument")}
                style={{ padding: 0, lineHeight: 1, color: "black", border: "none", boxShadow: "none" }} 
                onClick={() => { onDownload(object) }}>
                <i className="bi bi-download" />
            </Button>
            )}

        </div>
    );
}
